import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import Icon from './../Icon';
import Dropdown from './../Dropdown';
import Select from './../Select';

import { userSetFieldFetch } from './../../store/user/actions';

const SubjectsTypeDropdown = props => {
    const { value, save, translate } = props;
    return (
        <Dropdown buttonClassName="lnk-dropdown" text={translate(`subjectsTypeFiler.${value}`)} closeAlways>
            <Select value={value} onChange={save} className="menu menu-selectable">
                <li key="all" value="all" className="menu-item">
                    {translate('subjectsTypeFiler.all')}
                    <Icon className="svg-icon" iconName="check-empty" />
                </li>
                <li key="my" value="my" className="menu-item">
                    {translate('subjectsTypeFiler.my')}
                    <Icon className="svg-icon" iconName="check-empty" />
                </li>
            </Select>
        </Dropdown>
    );
};

const mapStateToProps = (state, props) => ({
    translate: getTranslate(state.locale),
    value: state.user[props.name] || 'my'
});
const mapDispatchToProps = (dispatch, props) => ({
    save: value => dispatch(userSetFieldFetch(props.name, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(SubjectsTypeDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/SubjectsTypeDropdown.js